import queryClient from 'app/apiService/queryClient';
import { request } from 'utils/request';
import { header } from 'utils/auth';

const CRM_SETTINGS_STALE_TIME_MS = Infinity;

function getListUrl(dealershipId: string) {
  return `/api/v2/dealer-settings?dealer=${dealershipId}&type=CRM`;
}

function getQueryKey(dealershipId: string) {
  return ['crm-settings', dealershipId] as const;
}

async function fetchCRMSettingsFromNetwork(dealershipId: string): Promise<any> {
  const requestURL = getListUrl(dealershipId);
  const response: any = await request(requestURL, {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: header(),
    }),
  });

  if (!response) {
    throw new Error('Failed to fetch crm settings from API');
  }

  return response;
}

class CrmSettingsApiService {
  static async getCRMSettings(dealershipId: string): Promise<any> {
    if (!dealershipId) {
      throw new Error('Dealer ID is required to fetch CRM settings');
    }

    return queryClient.fetchQuery({
      queryKey: getQueryKey(dealershipId),
      queryFn: () => fetchCRMSettingsFromNetwork(dealershipId),
      staleTime: CRM_SETTINGS_STALE_TIME_MS,
      cacheTime: CRM_SETTINGS_STALE_TIME_MS,
    });
  }

  static invalidateCRMSettingsCache(dealershipId: string) {
    if (!dealershipId) {
      return;
    }

    void queryClient.invalidateQueries({
      queryKey: getQueryKey(dealershipId),
    });
  }
}

export default CrmSettingsApiService;
